import { Grid, GridItem, GridRow } from './../Grid';
import React from 'react';
import { CorpContactCard } from '../CorpContactCard';
import { Container, Item } from './styles';

import { ICorpContactCardContainerProps } from './types';

export const CorpContactCardContainer = (props: ICorpContactCardContainerProps) => {
  const {
    id = 'contact-card-container',
    data,
  } = props;
  const { corpContactCards } = data;
  return <Container data-test={[`${id}-container`]}>
    {corpContactCards &&
      corpContactCards?.map((card: any, index: number) => (
        <Item
          key={card.id}
          style={{ width: '304px' }}
        >
          <CorpContactCard data-test={[`${id}-card1`]} {...card} />
        </Item>
      ))}
  </Container>
}

CorpContactCardContainer.defaultProps = {
  id: 'corp-contact-card-container',
};
